import ShareAfterGive from '../../share/ShareAfterGive';
import { useEffect } from 'react';
import { trackPageView } from '../../../support-and-tracking/analytics-actions';
import BosseAfterGiveTVA from '../../share/BosseAfterGiveTVA';
import { isProjectPartOfTVA } from '../../project-model';
import { useSelector } from 'react-redux';
import { useProject } from '../../project-hooks/useProject';
import styles from './share-please.module.less';
import { useOutletContext } from 'react-router';
import GiveContentWrapper from '../../post-payment/GiveContentWrapper';

const SharePlease = () => {
    const project = useProject();
    const transactionForGiverInfo = useSelector((state) => state.transactions.transactionForGiverInfo);
    const { isOnShareStep } = useOutletContext();
    const sharePath = pathToProject(project, transactionForGiverInfo?.subproject_id);

    useEffect(() => trackPageView({ urlAsEvent: 'project-payment-share', properties: { projectId: project.id } }), []);
    const campaigns = useSelector((state) => state.campaigns);
    return (
        <GiveContentWrapper isOnShareStep={isOnShareStep}>
            <div>
                {project.profile?.showSharing ? (
                    <div className={styles.shareContainer}>
                        {isProjectPartOfTVA(campaigns, project) ? (
                            <BosseAfterGiveTVA />
                        ) : (
                            <ShareAfterGive
                                path={sharePath}
                                projectId={project.id}
                                subprojectId={transactionForGiverInfo?.subproject_id}
                            />
                        )}
                    </div>
                ) : null}
            </div>
        </GiveContentWrapper>
    );
};

function pathToProject(project, subProjectId) {
    return `/project/${project?.id}${subProjectId ? `?subproject=${subProjectId}` : ``}`;
}

export default SharePlease;
